import { FC } from 'react';
import { Alert } from './AlertInvalidationRequested.style';

const AlertInvalidationRequested: FC = () => {
    return <Alert message="Invalidation has been requested" type="info" showIcon />;
};
export default AlertInvalidationRequested;
